<app-header></app-header>
<app-side-navigation-menu>
</app-side-navigation-menu>